import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const ImmoScout24Icon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon
      viewBox="0 0 34 42"
      sx={{
        width: "34px",
        height: "42px",
      }}
      {...props}
    >
      <svg
        width="34"
        height="42"
        viewBox="0 0 34 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M21 1.53906V9.80015C21 10.9203 21 11.4803 21.218 11.9081C21.4097 12.2845 21.7157 12.5904 22.092 12.7822C22.5198 13.0001 23.0799 13.0001 24.2 13.0001H32.4611M21 1H10.6C7.23968 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V31.4C1 34.7603 1 36.4405 1.65396 37.7239C2.2292 38.8529 3.14708 39.7708 4.27606 40.346C5.55953 41 7.23968 41 10.6 41H23.4C26.7603 41 28.4405 41 29.7239 40.346C30.8529 39.7708 31.7708 38.8529 32.346 37.7239C33 36.4405 33 34.7603 33 31.4V13L21 1Z"
          stroke="#6C757C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="8.42773" y="17" width="17.1429" height="17.1429" fill="url(#pattern0_189_900)" />
        <defs>
          <pattern id="pattern0_189_900" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlinkHref="#image0_189_900" transform="scale(0.0208333)" />
          </pattern>
          <image
            id="image0_189_900"
            width="48"
            height="48"
            preserveAspectRatio="none"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAABWElEQVRYCe2VQW7CMBREs2HTTcUFeoOuOIPPlN4tuUMLEuop4iv8SkQVGc8QHLuWKPpRhPJHHnh+RElnD3Z0D8ZjzwgUY/y4HDHGet+1hsZxDCEcLkcIYRiGSqZyoFnMjLL87Pt+mqZirEKgpZglzXxdo2oz0C0xjFWmahvQuhhmKlCVC5QvhrE2qcoC2iqGmfJV3QGqEcNYOarWgOrFMNNdVRrob8Uw1ooqAdRCDDPdUiWAuNwu4Qe6A6FtN4Q+eHJD7AQTN4Q+eHJD7AST5zXEO+MEXeiJW4XvMv4iTjQCptxyIDd0vSvQhZ6uq3+vus4+k1NXMU0qcsSGnkSRI13FlFucYENP3HJDaEoYerFjkmJFT0lFjrqJqSi+2ilJsaKnpCJH3cRUFB0IFP1PQ4KaHp4N1/A91PDHcjbmQOmrM/1D3uycRjli2615t++9nVqcO/sq2OoPj20rFWuoPWsAAAAASUVORK5CYII="
          />
        </defs>
      </svg>
    </SvgIcon>
  );
};
